import { IndexPage, MetaData } from '@/components'
import { NextPage } from 'next'
import { initializeStore } from '@/store'
import {fetchAreas, fetchMobileApps} from '@/store/slices/stagesSlice/stagesSlice'

const NextIndexPage: NextPage = () => {
  return (
    <>
      <MetaData />
      <IndexPage />
    </>
  )
}

NextIndexPage.getInitialProps = async () => {
  const reduxStore = initializeStore()
  const { dispatch } = reduxStore

  await dispatch(fetchAreas())
  await dispatch(fetchMobileApps())

  return {
    initialReduxState: reduxStore.getState(),
    headerLayout: 'empty',
  }
}

export default NextIndexPage
